import { render, staticRenderFns } from "./TheFaqView.vue?vue&type=template&id=07fc67e9&scoped=true"
import script from "./TheFaqView.vue?vue&type=script&lang=js"
export * from "./TheFaqView.vue?vue&type=script&lang=js"
import style0 from "./TheFaqView.vue?vue&type=style&index=0&id=07fc67e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc67e9",
  null
  
)

export default component.exports